var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-header"},[_c('h1',{staticClass:"style-h3"},[_vm._v("Your Cart")]),_c('a',{attrs:{"href":"/collections/all"}},[_c('btn',{attrs:{"type":"text","theme":"utility"}},[_vm._v("Continue Shopping")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }